export default __webpack_public_path__ + "static/media/logotitle.10e4f04b.png";